import React from 'react';
import { RotateCcw } from 'lucide-react';

interface ActionButtonsProps {
  isEditing: boolean;
  isPaidInitial: boolean;
  isSubmitting: boolean;
  hasClipboard: boolean;
  onClose: () => void;
  onCopy: () => void;
  onPaste: () => void;
  onDelete: () => void;
  onProcessToggle: () => void;
  onSubmit: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isEditing,
  isPaidInitial,
  isSubmitting,
  hasClipboard,
  onClose,
  onCopy,
  onPaste,
  onDelete,
  onProcessToggle,
  onSubmit
}) => {
  return (
    <div className='flex flex-col sm:flex-row items-center sm:items-center justify-between gap-2 border-t pt-3'>
      <span className='text-xs text-slate-500'>
        Review details before submitting.
      </span>

      <div className='w-full sm:w-auto'>
        <div className='flex flex-wrap gap-2 sm:flex-nowrap'>
          {!isPaidInitial && hasClipboard && (
            <button
              type='button'
              onClick={onPaste}
              className='flex-[0_0_48%] sm:flex-none px-4 py-2 bg-transparent border border-gray-300 text-slate-700 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500'
            >
              Paste
            </button>
          )}

          {isEditing && (
            <button
              type='button'
              onClick={onCopy}
              className='flex-[0_0_48%] sm:flex-none px-4 py-2 bg-transparent border border-gray-300 text-slate-700 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500'
            >
              Copy
            </button>
          )}

          <button
            type='button'
            onClick={onClose}
            className='flex-[0_0_48%] sm:flex-none px-4 py-2 bg-transparent border border-gray-300 text-slate-700 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500'
          >
            Close
          </button>

          {!isPaidInitial && isEditing && (
            <button
              type='button'
              onClick={onDelete}
              className='flex-[0_0_48%] sm:flex-none px-4 py-2 bg-transparent border border-gray-300 text-slate-700 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500'
            >
              Delete
            </button>
          )}

          {isPaidInitial ? (
            <button
              type='button'
              onClick={onProcessToggle}
              className='flex-[0_0_48%] sm:flex-none px-4 py-2 bg-transparent border border-gray-300 text-slate-700 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500 flex items-center gap-2'
            >
              <RotateCcw className='w-4 h-4' />
              Move as Unprocessed
            </button>
          ) : (
            <button
              type='submit'
              disabled={isSubmitting}
              onClick={onSubmit}
              className='flex-[0_0_48%] sm:flex-none px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50'
            >
              {isEditing ? 'Update Lesson' : 'Add Lesson'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActionButtons;
